import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '@/shared/ui/core';
import Text from './Text.styled';

const modifierProps = ['alert', 'help', 'header', 'light', 'regular', 'inverted', 'caption', 'small'];

export default ({
  content,
  children,
  as,
  ...props
}) => (
  <Text
    modifiers={getModifiers(props, modifierProps)}
    as={as}
    {...props}
  >
    {content ?? children}
  </Text>
);

Text.propTypes = {
  content: PropTypes.string,
  modifiers: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

Text.defaultProps = {
  modifiers: '',
  content: '',
};
